import { render } from "./kick.vue?vue&type=template&id=00149150&ts=true"
import script from "./kick.vue?vue&type=script&lang=ts"
export * from "./kick.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/kick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00149150"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00149150', __exports__)) {
    api.reload('00149150', __exports__)
  }
  
  module.hot.accept("./kick.vue?vue&type=template&id=00149150&ts=true", () => {
    api.rerender('00149150', render)
  })

}


export default __exports__